import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#19ADE4",
      d: "M10 15.833q-2.937-2.166-4.385-4.208-1.449-2.041-1.448-4 0-2.604 1.625-4.281T10 1.667t4.208 1.677 1.625 4.281q0 1.959-1.448 4T10 15.833m0-6.666q.687 0 1.177-.49t.49-1.177-.49-1.177A1.6 1.6 0 0 0 10 5.833q-.687 0-1.177.49T8.333 7.5t.49 1.177 1.177.49m-5.833 9.166v-1.666h11.666v1.666z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "location-underline"}) } }